import { render, staticRenderFns } from "./ot-tabs.vue?vue&type=template&id=3f9df666&scoped=true&"
import script from "./ot-tabs.vue?vue&type=script&lang=ts&"
export * from "./ot-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./ot-tabs.vue?vue&type=style&index=0&id=3f9df666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9df666",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
